import styled from "styled-components";
import {
  WHITE,
  LABEL_PRIMARY,
  TEXT_PRIMARY,
  BORDER_PRIMARY,
} from "@/constants/colors";
import { BODY } from "@/constants/fonts";
import { NARROW_SCREEN } from "@/constants/layout";

export const DateInput = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 50%;
  margin: 0.5rem 0;
  & > input {
    border: none;
  }
  z-index: 1060;
`;

export const DateInputIconWrapper = styled.div`
  margin-top: -4px;
  font-size: 1.3rem;
  padding-left: 24px;
`;

export const DatesRow = styled.div`
  display: flex;
  justify-content: center;
  background-color: ${WHITE};
  align-items: center;
  height: 100%;
  width: 356px;
  ${NARROW_SCREEN} {
    width: 100%;
  }
`;

export const DateInputDivider = styled.div`
  height: 100%;
  width: 0px;
  border-right: 1px solid #dee2e6;
`;

export const ClearDatesWrapper = styled.div`
  margin-left: 200px;
  height: 38px;
  cursor: pointer;
  margin-top: -11px;
  margin-bottom: 4px;
`;

export const CalendarActionsRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 0 24px 16px;
`;

export const DateFilterRow = styled.div`
  display: flex;
  padding: 24px;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid ${BORDER_PRIMARY};
`;

export const FilterDatesLabel = styled.div`
  height: 100%;
  justify-content: center;
  font-size: 14px;
  font-family: ${BODY};
  color: ${LABEL_PRIMARY};
`;

export const FilterType = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  width: 175px;
  font-family: ${BODY};
  font-size: 16px;
  color: ${TEXT_PRIMARY};
`;
